import useCheckPermissions from 'hooks/auth/useCheckPermission';
import PropTypes from 'prop-types';

/**
 * This element is use to hide or show element based on the user permissions setting
 * It accepts three props of which two are required and the other optional
 * requiredPermission prop specifies the permission that must be present for the child element of the PermissionGuard to be rendered.
 * Any UI element that should be rendered on permission verification is passed as the a child of the permission guard. if there are multiple element, they must be wrapped in a React.Fragment.
 * The defaultElement is used for an if..else scenario. The defaultElement prop is optional and should be specified if you have a UI element to render when the permission verification fails. The default value for the defaultElement prop is null; no element will be rendered.
 */
function PermissionGuard({ requiredPermission, children, defaultElement }) {
  const { userCheckPermission } = useCheckPermissions();
  const doesUserHavePermission = userCheckPermission(requiredPermission);

  return doesUserHavePermission ? children : defaultElement;
}

export default PermissionGuard;

PermissionGuard.defaultProps = {
  defaultElement: null,
};

PermissionGuard.propTypes = {
  children: PropTypes.element.isRequired,
  defaultElement: PropTypes.element,
  requiredPermission: PropTypes.string.isRequired,
};
